import { convertObjectToParams, PAGE_DEFAULT } from "@/utils";
import { REPORT_WORK_SCHEDULE_LIST, SET_PAGES } from "../mutation-types";
import http from "./helpers/httpInterceptor";
const state = () => ({
  DataReportDetail: [],
  DataReportSummary: [],
  dataCheckIOReport: [],
  ExportReport: [],
  reportWorkScheduleList: [],
  pages: PAGE_DEFAULT,
});

const mutations = {
  REPORT_DETAIL_DATA(states, payload) {
    states.DataReportDetail = payload;
  },
  REPORT_SUMMARY_DATA(states, payload) {
    states.DataReportSummary = payload;
  },
  REPORT_CHECKIO_DATA(states, payload) {
    states.dataCheckIOReport = payload;
  },
  DOWNLOAD_EXCEL_DATA(states, payload) {
    states.ExportReport = payload;
  },
  [REPORT_WORK_SCHEDULE_LIST](state, data) {
    state.reportWorkScheduleList = data;
  },
  [SET_PAGES](state, data) {
    state.pages = data;
  },
};
const actions = {
  getDataReportDetail({ commit }, url) {
    return http
      .get("/tms/report/detail" + url)
      .then((res) => {
        commit("REPORT_DETAIL_DATA", res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },

  getDataReportSummary({ commit }, url) {
    return http
      .get("/tms/report/summary" + url)
      .then((res) => {
        commit("REPORT_SUMMARY_DATA", res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },

  getDataCheckIOReport({ commit }, url) {
    return http
      .get("tms/report/check-time" + url)
      .then((res) => {
        commit("REPORT_CHECKIO_DATA", res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getReportWorkScheduleList({ commit }, payload) {
    return http
      .get(`/tms/report/work-schedule${convertObjectToParams(payload)}`)
      .then((res) => {
        const {
          data,
          page: { page, size, total_element },
        } = res.data;
        commit(REPORT_WORK_SCHEDULE_LIST, data ?? []);
        commit(SET_PAGES, {
          page,
          size,
          total: total_element,
        });
        return res.data;
      })
      .catch((err) => {
        commit(REPORT_WORK_SCHEDULE_LIST, []);
        commit(SET_PAGES, PAGE_DEFAULT);
        throw err;
      });
  },
  exportReportWorkSchedule(_, payload) {
    return http
      .get(`/tms/excel/job-info-mapping${convertObjectToParams(payload)}`, { responseType: "blob" })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
